import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
export var extractSadadInfo = function extractSadadInfo(response) {
  var _response$step_body, _response$step_body$d, _response$step_body$d2;
  var saddad = {};
  if (response !== null && response !== void 0 && (_response$step_body = response.step_body) !== null && _response$step_body !== void 0 && (_response$step_body$d = _response$step_body.data) !== null && _response$step_body$d !== void 0 && (_response$step_body$d2 = _response$step_body$d.remaining_data) !== null && _response$step_body$d2 !== void 0 && _response$step_body$d2.paymentOptions) {
    saddad = {
      sadad: response.step_body.data.remaining_data.paymentOptions.sadad,
      hasSadad: response.step_body.data.remaining_data.paymentOptions.sadad.is_enabled,
      sadadError: "" //TODO: get the error from the response
    };
  }
  if (response !== null && response !== void 0 && response.paymentOptions) {
    saddad = {
      sadad: response.paymentOptions.sadad,
      hasSadad: response.paymentOptions.sadad.is_enabled,
      sadadError: "" //TODO: get the error from the response
    };
  }
  return saddad;
};
export function api__sendSadadInvoice(_x) {
  return _api__sendSadadInvoice.apply(this, arguments);
}
function _api__sendSadadInvoice() {
  _api__sendSadadInvoice = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(requestBody) {
    var _res$data2, res, _t;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.p = 0;
          _context2.n = 1;
          return fetcher().post('/order/send-sadad-invoice', requestBody);
        case 1:
          res = _context2.v;
          return _context2.a(2, res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.data);
        case 2:
          _context2.p = 2;
          _t = _context2.v;
          console.error(_t);
          return _context2.a(2, null);
      }
    }, _callee2, null, [[0, 2]]);
  }));
  return _api__sendSadadInvoice.apply(this, arguments);
}
export var api__addBankPayment = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(orderId, banks) {
    var _res$data;
    var isFinance,
      formData,
      res,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          isFinance = _args.length > 2 && _args[2] !== undefined ? _args[2] : 0;
          formData = new FormData();
          formData.append("order_id", orderId);
          formData.append("is_finance", isFinance);
          if (Object.keys(banks).length > 0) {
            Object.keys(banks).forEach(function (bankId) {
              formData.append("image[".concat(bankId, "]"), banks[bankId]);
            });
          }
          _context.n = 1;
          return fetcher().post("/order/add-payment", formData);
        case 1:
          res = _context.v;
          return _context.a(2, res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data);
      }
    }, _callee);
  }));
  return function api__addBankPayment(_x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();